module.exports = __webpack_public_path__ + "img/position-2.0ab178c8.png";